


export enum AnalysisConfigFieldType {

    Text = "text",
    Number = "number",
    ColumnSelect = "column_select",
    ColumnSelectOrCreate = "column_select_or_create",
    Boolean = "boolean",
    Select = "select",
    SelectJson = "select_json",
    SelectOrCreate = "select_or_create",
    SelectXorText = "select_xor_text",
    SelectXorSelect = "select_xor_select",
    TextXorSelect = "text_xor_select",
    MultiSelect = "multiselect",
    ColumnMultiSelect = "column_multiselect",
    ColumnMultiSelectOrCreate = "column_multiselect_or_create",
    ArrayValues = "array_values",
    Array = "array",
    Object = "object",
    Json = "json",
    ColorPicker = "color_picker",
    RegularExpression = "regex",
    StringTemplate = "string_template"
}